module.exports = __webpack_public_path__ + "static/media/title_10.ff413e98.svg";